<svg xmlns="http://www.w3.org/2000/svg"
     viewBox="-45 -45 90 90"
     width="100%" height="100%"
     preserveAspectRatio="xMidYMid meet"
     [class]="'ai-loader ' + class + (isStatic ? ' ai-loader-static' : '') + (colored ? ' colored' : '')"
     [style.animation-delay]="animationDelay">
  <style>
    /* 1. Global Rotation: Variable Speed (No Pause) */
    .ai-loader {
       animation: ai-rotate 12s infinite;
    }

    /* `colored` input — override the default white fill with the app's
       primary-button teal so the swirl picks up the active-tab colour. */
    .ai-loader.colored {
      --tidy-ai-loader-fill: var(--primary-button);
    }
    @keyframes ai-rotate {
      /* 0% (Sparkle): Start slow */
      0%   { transform: rotate(0deg); animation-timing-function: ease-in; }

      /* 25% (Swirl): Fast pass through chaos */
      25%  { transform: rotate(90deg); animation-timing-function: ease-out; }

      /* 50% (Sparkle): Slow down to show shape */
      50%  { transform: rotate(180deg); animation-timing-function: ease-in; }

      /* 75% (Swirl): Speed up */
      75%  { transform: rotate(270deg); animation-timing-function: ease-out; }

      /* 100% (Sparkle): Slow finish */
      100% { transform: rotate(360deg); }
    }

    /* 2. Particles */
    .ai-particle {
      fill: var(--tidy-ai-loader-fill, #ffffff);
      opacity: 0.9;
      animation-timing-function: ease-in-out;
      animation-iteration-count: infinite;
      animation-duration: 6s;
    }

    /* 3. Core Effects */
    .ai-core {
      fill: var(--tidy-ai-loader-fill, #ffffff);
      opacity: 0.8;
      animation: ai-pulse 3s ease-in-out infinite;
    }
    .ai-glow {
      fill: var(--tidy-ai-loader-fill, #ffffff);
      opacity: 0.3;
      animation: ai-ripple 3s cubic-bezier(0, 0, 0.2, 1) infinite;
    }
    @keyframes ai-pulse {
      0%, 100% { opacity: 0.8; transform: scale(1); }
      50% { opacity: 0.5; transform: scale(0.9); }
    }
    @keyframes ai-ripple {
      0% { opacity: 0.5; transform: scale(1); }
      100% { opacity: 0; transform: scale(3.5); }
    }

    /* Static mode: freeze particles in star shape (0% keyframe positions) */
    .ai-loader-static {
      animation: none !important;
    }
    .ai-loader-static .ai-particle {
      animation-play-state: paused !important;
      animation-delay: 0s !important;
    }
    .ai-loader-static .ai-core {
      animation: none !important;
    }
    .ai-loader-static .ai-glow {
      animation: none !important;
      opacity: 0;
    }

    @keyframes move-0 {
        0%, 100% { transform: translate(42.0px, 0.0px); }
        50%      { transform: translate(19.4px, 26.1px); }
    }
    @keyframes move-1 {
        0%, 100% { transform: translate(36.1px, 1.2px); }
        50%      { transform: translate(34.7px, 8.9px); }
    }
    @keyframes move-2 {
        0%, 100% { transform: translate(22.2px, 8.5px); }
        50%      { transform: translate(1.4px, 28.7px); }
    }
    @keyframes move-3 {
        0%, 100% { transform: translate(8.5px, 22.2px); }
        50%      { transform: translate(28.7px, 13.8px); }
    }
    @keyframes move-4 {
        0%, 100% { transform: translate(1.2px, 36.1px); }
        50%      { transform: translate(6.5px, 34.7px); }
    }
    @keyframes move-5 {
        0%, 100% { transform: translate(0.0px, 42.0px); }
        50%      { transform: translate(-16.4px, 21.7px); }
    }
    @keyframes move-6 {
        0%, 100% { transform: translate(-1.2px, 36.1px); }
        50%      { transform: translate(-31.0px, 11.6px); }
    }
    @keyframes move-7 {
        0%, 100% { transform: translate(-8.5px, 22.2px); }
        50%      { transform: translate(-15.7px, 29.5px); }
    }
    @keyframes move-8 {
        0%, 100% { transform: translate(-22.2px, 8.5px); }
        50%      { transform: translate(-6.7px, 35.6px); }
    }
    @keyframes move-9 {
        0%, 100% { transform: translate(-36.1px, 1.2px); }
        50%      { transform: translate(-11.6px, 26.4px); }
    }
    @keyframes move-10 {
        0%, 100% { transform: translate(-42.0px, 0.0px); }
        50%      { transform: translate(-15.7px, -23.7px); }
    }
    @keyframes move-11 {
        0%, 100% { transform: translate(-36.1px, -1.2px); }
        50%      { transform: translate(-12.7px, -30.0px); }
    }
    @keyframes move-12 {
        0%, 100% { transform: translate(-22.2px, -8.5px); }
        50%      { transform: translate(-15.9px, -27.8px); }
    }
    @keyframes move-13 {
        0%, 100% { transform: translate(-8.5px, -22.2px); }
        50%      { transform: translate(-14.7px, -33.1px); }
    }
    @keyframes move-14 {
        0%, 100% { transform: translate(-1.2px, -36.1px); }
        50%      { transform: translate(13.1px, -23.8px); }
    }
    @keyframes move-15 {
        0%, 100% { transform: translate(-0.0px, -42.0px); }
        50%      { transform: translate(-6.7px, -31.2px); }
    }
    @keyframes move-16 {
        0%, 100% { transform: translate(1.2px, -36.1px); }
        50%      { transform: translate(18.0px, -25.3px); }
    }
    @keyframes move-17 {
        0%, 100% { transform: translate(8.5px, -22.2px); }
        50%      { transform: translate(26.5px, -16.1px); }
    }
    @keyframes move-18 {
        0%, 100% { transform: translate(22.2px, -8.5px); }
        50%      { transform: translate(10.9px, -33.4px); }
    }
    @keyframes move-19 {
        0%, 100% { transform: translate(36.1px, -1.2px); }
        50%      { transform: translate(15.3px, -27.9px); }
    }
  </style>

  <g>
    <circle class="ai-glow" r="3" cx="0" cy="0" [style.animation-delay]="coreDelay" />
    <circle class="ai-core" r="1.5" cx="0" cy="0" [style.animation-delay]="coreDelay" />
    <circle class="ai-particle" r="7.7" cx="0" cy="0" [attr.style]="'animation-name: move-0; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="6.3" cx="0" cy="0" [attr.style]="'animation-name: move-1; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="5.6" cx="0" cy="0" [attr.style]="'animation-name: move-2; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="5.9" cx="0" cy="0" [attr.style]="'animation-name: move-3; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="7.9" cx="0" cy="0" [attr.style]="'animation-name: move-4; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="7.5" cx="0" cy="0" [attr.style]="'animation-name: move-5; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="3.9" cx="0" cy="0" [attr.style]="'animation-name: move-6; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="3.7" cx="0" cy="0" [attr.style]="'animation-name: move-7; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="5.5" cx="0" cy="0" [attr.style]="'animation-name: move-8; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="4.7" cx="0" cy="0" [attr.style]="'animation-name: move-9; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="5.1" cx="0" cy="0" [attr.style]="'animation-name: move-10; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="6.4" cx="0" cy="0" [attr.style]="'animation-name: move-11; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="7.2" cx="0" cy="0" [attr.style]="'animation-name: move-12; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="7.1" cx="0" cy="0" [attr.style]="'animation-name: move-13; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="6.4" cx="0" cy="0" [attr.style]="'animation-name: move-14; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="4.8" cx="0" cy="0" [attr.style]="'animation-name: move-15; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="6.1" cx="0" cy="0" [attr.style]="'animation-name: move-16; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="7.0" cx="0" cy="0" [attr.style]="'animation-name: move-17; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="6.2" cx="0" cy="0" [attr.style]="'animation-name: move-18; animation-delay: ' + particleDelay" />
    <circle class="ai-particle" r="5.4" cx="0" cy="0" [attr.style]="'animation-name: move-19; animation-delay: ' + particleDelay" />
  </g>
</svg>
